var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _g8, _path9, _g9, _path10, _g10, _path11, _g11, _path12, _g12, _path13, _g13, _path14, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnLlamama = function SvgIcnLlamama(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 152,
    viewBox: "0 0 152 152",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_11945)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_11945",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 148,
    height: 148
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.335 1.16788C35.6688 1.16788 2.70312 34.1336 2.70312 74.7997C2.70312 115.466 35.6688 148.432 76.335 148.432C117 148.432 149.966 115.466 149.966 74.7997C149.966 34.1336 117 1.16788 76.335 1.16788Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_11945)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.70312 148.432H149.967V1.16862H2.70312V148.432Z",
    fill: "#5F63F4"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_11945",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 148,
    height: 148
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.70312 74.7997C2.70312 115.466 35.6688 148.432 76.335 148.432C117 148.432 149.966 115.466 149.966 74.7997C149.966 34.1336 117 1.16788 76.335 1.16788C35.6688 1.16788 2.70312 34.1336 2.70312 74.7997Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_11945)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4004 152.331H125.644L127.45 108.079L123.385 80.5352L118.205 74.9127L104.873 89.1148L100.858 100.196L82.7463 93.9944L51.2003 99.22L42.5588 82.7935L34.3437 80.4594L29.9155 79.1804L26.3039 93.9944L25.4004 152.331Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_0_11945",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 148,
    height: 148
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.70312 74.7997C2.70312 115.466 35.6688 148.432 76.335 148.432C117 148.432 149.966 115.466 149.966 74.7997C149.966 34.1336 117 1.16788 76.335 1.16788C35.6688 1.16788 2.70312 34.1336 2.70312 74.7997Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_0_11945)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.4012 100.487C42.4012 100.487 37.9988 101.182 34.2907 103.114C34.2907 103.114 33.7944 93.7542 36.1889 91.3597C36.1889 91.3597 38.7704 92.5312 42.4012 100.487Z",
    fill: "#F8DCCD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_0_11945",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 148,
    height: 148
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.70312 74.7997C2.70312 115.466 35.6688 148.432 76.335 148.432C117 148.432 149.966 115.466 149.966 74.7997C149.966 34.1336 117 1.16788 76.335 1.16788C35.6688 1.16788 2.70312 34.1336 2.70312 74.7997Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_0_11945)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.359 100.487C110.359 100.487 114.762 101.182 118.47 103.114C118.47 103.114 118.965 93.7542 116.572 91.3597C116.572 91.3597 113.99 92.5312 110.359 100.487Z",
    fill: "#F8DCCD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_0_11945",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 148,
    height: 148
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.70312 74.7997C2.70312 115.466 35.6688 148.432 76.335 148.432C117 148.432 149.966 115.466 149.966 74.7997C149.966 34.1336 117 1.16788 76.335 1.16788C35.6688 1.16788 2.70312 34.1336 2.70312 74.7997Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_0_11945)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.84 138.573C78.7119 137.445 76.8306 137.445 75.7026 138.573L74.8293 139.446L73.9553 138.573C72.828 137.445 70.946 137.445 69.8187 138.573C68.6906 139.7 68.6906 141.582 69.8187 142.71L72.7603 145.652C73.8883 146.78 75.7703 146.78 76.8977 145.652L79.84 142.71C80.9673 141.582 80.9673 139.7 79.84 138.573Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_0_11945",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 148,
    height: 148
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.70312 74.7997C2.70312 115.466 35.6688 148.432 76.335 148.432C117 148.432 149.966 115.466 149.966 74.7997C149.966 34.1336 117 1.16788 76.335 1.16788C35.6688 1.16788 2.70312 34.1336 2.70312 74.7997Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_0_11945)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.6488 157.706C73.333 157.706 72.2676 156.639 72.2676 155.324V143.892C72.2676 142.577 73.333 141.511 74.6488 141.511C75.9639 141.511 77.0301 142.577 77.0301 143.892V155.324C77.0301 156.639 75.9639 157.706 74.6488 157.706Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_0_11945",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 148,
    height: 148
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.70312 74.7997C2.70312 115.466 35.6688 148.432 76.335 148.432C117 148.432 149.966 115.466 149.966 74.7997C149.966 34.1336 117 1.16788 76.335 1.16788C35.6688 1.16788 2.70312 34.1336 2.70312 74.7997Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_0_11945)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.474 134.716C101.413 136.267 98.2457 137.399 94.4022 137.239C90.5571 137.079 87.4918 135.694 87.5537 134.141C87.6148 132.589 90.7824 131.458 94.6275 131.618C98.4703 131.778 101.536 133.165 101.474 134.716Z",
    fill: "#F8DCCD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_0_11945",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 148,
    height: 148
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.70312 74.7997C2.70312 115.466 35.6688 148.432 76.335 148.432C117 148.432 149.966 115.466 149.966 74.7997C149.966 34.1336 117 1.16788 76.335 1.16788C35.6688 1.16788 2.70312 34.1336 2.70312 74.7997Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_0_11945)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.6053 134.716C63.5442 136.267 60.3766 137.399 56.5337 137.239C52.688 137.079 49.6227 135.694 49.6845 134.141C49.7456 132.589 52.9133 131.458 56.7583 131.618C60.6012 131.778 63.6665 133.165 63.6053 134.716Z",
    fill: "#F8DCCD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_0_11945",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 148,
    height: 148
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.70312 74.7997C2.70312 115.466 35.6688 148.432 76.335 148.432C117 148.432 149.966 115.466 149.966 74.7997C149.966 34.1336 117 1.16788 76.335 1.16788C35.6688 1.16788 2.70312 34.1336 2.70312 74.7997Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_0_11945)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.029 122.985H91.4858C91.4593 122.985 91.4379 122.999 91.4122 123.001C91.3864 123 91.3658 122.985 91.3385 122.985C89.6406 122.985 88.2637 124.362 88.2637 126.061V128.733C88.2637 128.764 88.2791 128.789 88.2806 128.818C88.2791 128.876 88.2637 128.931 88.2637 128.989C88.2637 132.305 90.9512 134.994 94.2676 134.994C97.584 134.994 100.272 132.305 100.272 128.989C100.272 128.535 100.212 128.097 100.116 127.671H102.029C103.324 127.671 104.373 126.622 104.373 125.329C104.373 124.034 103.324 122.985 102.029 122.985Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_0_11945",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 148,
    height: 148
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.70312 74.7997C2.70312 115.466 35.6688 148.432 76.335 148.432C117 148.432 149.966 115.466 149.966 74.7997C149.966 34.1336 117 1.16788 76.335 1.16788C35.6688 1.16788 2.70312 34.1336 2.70312 74.7997Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_0_11945)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.117 122.985H54.573C54.5472 122.985 54.5258 122.999 54.5001 123.001C54.4743 123 54.4529 122.985 54.4264 122.985C52.7285 122.985 51.3516 124.362 51.3516 126.061V128.733C51.3516 128.764 51.367 128.789 51.3685 128.818C51.367 128.876 51.3516 128.931 51.3516 128.989C51.3516 132.305 54.0399 134.994 57.3555 134.994C60.6719 134.994 63.3594 132.305 63.3594 128.989C63.3594 128.535 63.2998 128.097 63.2041 127.671H65.117C66.4107 127.671 67.4607 126.622 67.4607 125.329C67.4607 124.034 66.4107 122.985 65.117 122.985Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_0_11945",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 148,
    height: 148
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.70312 74.7997C2.70312 115.466 35.6688 148.432 76.335 148.432C117 148.432 149.966 115.466 149.966 74.7997C149.966 34.1336 117 1.16788 76.335 1.16788C35.6688 1.16788 2.70312 34.1336 2.70312 74.7997Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_0_11945)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.6776 476.529C77.0819 476.529 77.5001 476.629 77.9154 476.817C78.9079 477.266 79.3858 478.375 79.3858 479.464V515.121C79.3858 538.024 88.4234 542.366 105.098 542.366C106.046 542.366 107.007 542.353 107.977 542.331C120.489 542.054 123.072 531.788 124.513 522.187C124.612 521.529 124.702 520.934 124.79 520.417C128.021 501.616 132.027 464.427 132.333 459.987C132.372 459.417 132.587 458.872 132.949 458.427C140.822 448.76 147.263 428.62 151.087 401.716C151.229 400.717 151.902 399.874 152.845 399.515C153.789 399.156 154.851 399.337 155.621 399.988C164.513 407.494 173.57 413.905 182.568 419.065C188.314 414.614 191.091 410.334 190.83 406.33C190.443 400.429 183.374 395.67 179.621 393.548C174.791 394.1 173.33 394.212 172.512 394.212C171.153 394.212 170.17 393.731 169.593 392.783C169.358 392.397 168.901 391.41 169.403 390.176C171.517 379.329 153.683 334.013 146.036 314.586C143.895 309.148 142.205 304.852 141.419 302.594C138.85 295.209 130.556 236.489 127.766 205.932C125.764 184.006 123.91 159.952 123.91 132.644C123.91 128.251 124.11 123.701 124.303 119.302C124.756 108.988 125.224 98.3231 123.199 88.6206C122.687 86.1665 121.19 80.4593 118.346 80.4593C114.292 80.4593 107.292 89.1353 104.728 97.3379C104.707 97.4064 104.684 97.4741 104.656 97.5411L104.257 98.5388C103.74 99.8311 102.343 100.539 100.999 100.196C92.9061 98.1398 84.0003 97.0971 74.5291 97.0971C61.2289 97.0971 51.4381 99.1986 51.3409 99.2199C49.9397 99.5277 48.5304 98.7097 48.1019 97.3379C45.5387 89.1353 38.5393 80.4593 34.4844 80.4593C31.6415 80.4593 30.1438 86.1665 29.6313 88.6206C27.6064 98.3231 28.0747 108.988 28.5276 119.3C28.7212 123.7 28.9208 128.251 28.9208 132.644C28.9208 149.954 27.7441 166.48 26.6065 182.461C26.0653 190.061 25.5057 197.92 25.0728 205.831C21.83 265.061 17.4062 293.611 10.2786 301.298C-13.2106 326.633 -38.1004 338.261 -56.2742 346.753C-79.1376 357.436 -90.6132 362.797 -84.2168 383.184C-81.1147 393.072 -68.1496 395.148 -57.819 395.148C-40.207 395.148 -19.6542 389.329 -8.01003 383.923C-7.14264 383.521 -6.13094 383.593 -5.32983 384.114C-4.52944 384.635 -4.05305 385.531 -4.06999 386.487C-4.89909 433.762 9.27726 452.109 16.0904 460.927C16.4092 461.338 16.6058 461.832 16.6559 462.352C18.6152 482.374 21.5399 508.095 23.6583 520.417C23.849 521.529 23.944 522.848 24.0537 524.377C24.748 534.054 26.228 542.085 37.3494 542.331C38.3184 542.353 39.2719 542.366 40.2041 542.366C53.7634 542.366 63.3613 540.412 63.3613 515.121V479.939C63.3606 479.607 63.4187 479.276 63.5351 478.964C64.0041 477.705 65.3074 476.965 66.6262 477.202C66.7793 477.229 66.928 477.269 67.0709 477.32C67.4678 477.365 68.6672 477.457 71.8445 477.457C73.8789 477.457 74.8766 477.179 75.1785 477.074C75.635 476.702 76.1453 476.529 76.6776 476.529ZM105.098 547.912C88.863 547.912 73.8406 543.94 73.8406 515.121V482.924C73.2479 482.974 72.5852 483.002 71.8444 483.002C70.7422 483.002 69.7673 483.002 68.9073 482.984V515.121C68.9073 528.466 66.3728 537.034 60.9307 542.083C55.4098 547.206 47.7057 547.912 40.2041 547.912C39.2322 547.912 38.2374 547.898 37.2264 547.876C20.1519 547.498 19.0511 532.15 18.5217 524.774C18.4223 523.392 18.3369 522.199 18.1919 521.356C16.0786 509.061 13.182 483.69 11.2138 463.685C4.07149 454.419 -9.59974 435.698 -9.65054 390.678C-22.1805 395.779 -41.2349 400.694 -57.819 400.694C-75.2977 400.694 -86.2564 395.213 -89.5094 384.843C-97.3578 359.827 -81.1095 352.234 -58.6223 341.729C-39.8735 332.969 -16.5403 322.067 6.21197 297.527C15.0183 288.03 18.4172 225.933 19.5349 205.527C19.9701 197.571 20.5319 189.688 21.0738 182.067C22.2571 165.451 23.3748 149.757 23.3748 132.644C23.3748 128.373 23.1775 123.884 22.9868 119.544C22.5185 108.889 22.0347 97.8717 24.2017 87.4874C26.3709 77.0943 30.9906 74.9133 34.4844 74.9133C41.7732 74.9133 49.2792 85.1106 52.5617 93.3449C56.381 92.6858 64.4238 91.5512 74.5291 91.5512C83.5239 91.5512 92.0542 92.4539 99.9276 94.2365C103.005 85.8668 110.793 74.9133 118.346 74.9133C121.84 74.9133 126.46 77.0943 128.629 87.4874C130.796 97.8717 130.312 108.89 129.844 119.545C129.654 123.884 129.456 128.373 129.456 132.644C129.456 159.73 131.298 183.632 133.289 205.427C136.193 237.228 144.424 294.353 146.658 300.772C147.406 302.925 149.079 307.175 151.197 312.555C162.376 340.958 174.043 371.746 175.017 386.442C175.377 386.241 175.785 386.118 176.218 386.095L210.955 384.2C212.45 384.115 213.737 385.237 213.868 386.727C213.999 388.217 212.924 389.542 211.44 389.722L206.413 390.332C198.617 391.278 192.671 391.999 188.074 392.55C192.171 395.825 195.996 400.349 196.364 405.968C196.78 412.322 192.754 418.597 184.398 424.619C183.525 425.247 182.365 425.314 181.426 424.79C172.89 420.03 164.302 414.179 155.847 407.363C152.892 426.017 147.474 448.772 137.797 461.24C137.14 468.994 133.253 503.922 130.257 521.356C130.173 521.839 130.091 522.395 129.998 523.01C128.9 530.329 126.328 547.472 108.1 547.876C107.088 547.899 106.087 547.912 105.098 547.912Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_0_11945",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 148,
    height: 148
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.70312 74.7997C2.70312 115.466 35.6688 148.432 76.335 148.432C117 148.432 149.966 115.466 149.966 74.7997C149.966 34.1336 117 1.16788 76.335 1.16788C35.6688 1.16788 2.70312 34.1336 2.70312 74.7997Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_0_11945)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.3186 18.3416H62.4276C50.3115 18.3416 40.3984 28.2547 40.3984 40.3708C40.3984 52.4869 50.3115 62.3992 62.4276 62.3992H69.9255V74.7952L82.3215 62.3992H90.3186C102.434 62.3992 112.347 52.4869 112.347 40.3708C112.347 28.2547 102.434 18.3416 90.3186 18.3416Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_0_11945",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 148,
    height: 148
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.70312 74.7997C2.70312 115.466 35.6688 148.432 76.335 148.432C117 148.432 149.966 115.466 149.966 74.7997C149.966 34.1336 117 1.16788 76.335 1.16788C35.6688 1.16788 2.70312 34.1336 2.70312 74.7997Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_0_11945)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.4269 21.1643C51.8379 21.1643 43.223 29.78 43.223 40.3704C43.223 50.9609 51.8379 59.5773 62.4269 59.5773H69.9271C71.4844 59.5773 72.7501 60.8408 72.7501 62.3996V67.9816L80.3239 60.4042C80.854 59.8748 81.5727 59.5773 82.3208 59.5773H90.3187C100.908 59.5773 109.523 50.9609 109.523 40.3704C109.523 29.78 100.908 21.1643 90.3187 21.1643H62.4269ZM69.9271 77.6171C69.5626 77.6171 69.1959 77.5486 68.8454 77.4028C67.791 76.9662 67.1033 75.9376 67.1033 74.7955V65.2219H62.4269C48.724 65.2219 37.5762 54.0748 37.5762 40.3704C37.5762 26.6675 48.724 15.5197 62.4269 15.5197H90.3187C104.022 15.5197 115.169 26.6675 115.169 40.3704C115.169 54.0748 104.022 65.2219 90.3187 65.2219H83.4908L71.9232 76.7902C71.382 77.3314 70.6604 77.6171 69.9271 77.6171Z",
    fill: "black"
  })))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.8424 42.9773L74.0036 48.1474C74.0759 48.2209 74.1745 48.2622 74.2775 48.2622C74.3804 48.2622 74.4791 48.2209 74.5514 48.1474L84.8246 37.8488C85.6283 37.0399 86.0533 35.9283 85.9946 34.7883C85.936 33.6484 85.3992 32.5864 84.5168 31.8646C82.8305 30.5669 80.4399 30.7483 78.9678 32.2855L68.8424 42.4315C68.6934 42.5828 68.6934 42.826 68.8424 42.9773ZM66.9235 50.9846L71.76 50.0147C71.8992 49.9869 72.0119 49.8846 72.0531 49.7485C72.0943 49.6124 72.0573 49.4646 71.9569 49.364L67.6313 45.0327C67.5309 44.9321 67.3834 44.8951 67.2476 44.9363C67.1117 44.9776 67.0096 45.0905 66.9819 45.2301L66.0156 50.0748C65.9693 50.3017 66.0273 50.5373 66.1735 50.7167C66.3196 50.896 66.5385 51 66.7696 51C66.8213 51.0004 66.8729 50.9952 66.9235 50.9846Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_11945",
    x: 0.703125,
    y: 0.168617,
    width: 151.264,
    height: 151.264,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_11945"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_11945",
    result: "shape"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnLlamama, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_llamama.e858e3ea.svg";
export { ForwardRef as ReactComponent };